import React, { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import { useNavigate } from 'react-router-dom';
import styles from '../components/hesabim.module.css';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

const AdminAccount = () => {
    const [user, setUser] = useState(null);
    const [userData, setUserData] = useState(null);
    const [message2, setMessage2] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
            if (firebaseUser) {
                setUser(firebaseUser);
                const docRef = doc(db, 'users', firebaseUser.uid);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    setUserData(docSnap.data());
                }
            } else {
                navigate('/giris');
            }
        });
        return () => unsubscribe();
    }, [navigate]);

    const handleLogout = async () => {
        try {
            await auth.signOut();
            localStorage.removeItem('token');
            setMessage2('Başarılı bir şekilde çıkış yapıldı.');
        } catch (error) {
            console.error('Logout Error:', error);
        }
    };

    if (!user) {
        return null; // Kullanıcı yüklenene kadar bir şey gösterme
    }

    return (
        <main className={styles.main}>
            <section className={styles.section}>
                <div>
                    <h1 className={styles.header}>Hoş Geldiniz, {userData?.firstName} {userData?.lastName}</h1>

                    <section className={styles.infoSection}>
                        <h2>Bilgilerim</h2>
                        <ul className={styles.infoList}>
                            <li><span className={styles.infoLabel}>Ad:</span> {userData?.firstName}</li>
                            <li><span className={styles.infoLabel}>Soyad:</span> {userData?.lastName}</li>
                            <li><span className={styles.infoLabel}>Email:</span> {user.email}</li>
                            <li><span className={styles.infoLabel}>Doğum Tarihi:</span> {userData?.birthDate}</li>
                            <li><span className={styles.infoLabel}>Telefon Numarası:</span> {userData?.phone}</li>
                        </ul>
                    </section>
                </div>
                <button onClick={handleLogout} className={styles.button}>Çıkış Yap</button>
                {message2 && <p className={styles.successMessage}>{message2}</p>}
            </section>
        </main>
    );
}

export default AdminAccount;
